import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class EntitatiService {
  private token!: string;
  private httpOptions: any;

  private basePath = environment.interop.basePath;

  private getEntitatiDTUrl = this.basePath + environment.interop.indoc.entitati.getEntitatiDT;
  private viewEntitatiDTUrl = this.basePath + environment.interop.indoc.entitati.viewEntitati;
  private searchEntitatiDTUrl = this.basePath + environment.interop.indoc.entitati.searchEntitati;



  constructor(private http: HttpClient) { }

  getEntitatiDT() {
    return this.http.get(this.getEntitatiDTUrl, this.httpOptions);
  }

  findEntitate(id: number) {
    return this.http.get(this.viewEntitatiDTUrl + id, this.httpOptions);
  }

  searchEntitatiDT(name: any) {
    return this.http.post(this.searchEntitatiDTUrl, name, this.httpOptions);
  }

  setToken(token: string) {
    this.token = token;
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${this.token}`,
      }),
    };
  }

}
